// Import model
import { DataviewContactNoteResponse } from '../models/DataviewContactNoteResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ContactNote } from '../models/ContactNote';
import { DataView } from '../models/DataView';
import { FilterContactNoteRequest } from '../models/FilterContactNoteRequest';

// Import dependency serializers (for complex types)
import { ContactNoteSerializer } from './ContactNoteSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterContactNoteRequestSerializer } from './FilterContactNoteRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewContactNoteResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewContactNoteResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewContactNoteResponse instance
   */
  static deserialize(json: string): DataviewContactNoteResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewContactNoteResponse instance
   */
  static fromObject(obj: any): DataviewContactNoteResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewContactNoteResponse');
    }


    const instance: DataviewContactNoteResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ContactNoteSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterContactNoteRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewContactNoteResponse instances
   */
  static deserializeArray(json: string): DataviewContactNoteResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewContactNoteResponse instance to a JSON string
   */
  static serialize(instance: DataviewContactNoteResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewContactNoteResponse instance to a plain object
   */
  static toObject(instance: DataviewContactNoteResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ContactNoteSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterContactNoteRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewContactNoteResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewContactNoteResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
